<template>
  <div class="order-calendar">
    <calendar-view
      :items="calendarItems"
      :show-date="calendarShowDate"
      currentPeriodLabel="Today"
      class="theme-gcal"
    >
      <calendar-view-header
        slot="header"
        slot-scope="t"
        :header-props="t.headerProps"
        @input="(v) => (calendarShowDate = v)"
      />

      <template #item="{ value }">
        <div
          :class="
            [
              'cv-item',
              `${orderSelected && orderSelected.id == value.id ? 'isRed' : ''}`,
              ...value.classes,
            ].join(' ')
          "
          :style="`top: calc(${2.5 + value.itemRow * 2}em + ${
            6 * value.itemRow
          }px);`"
          :data-order-id="value.id"
          @click="onCalendarItemClick(value.originalItem)"
          @mouseenter="onCalendarItemHover"
          @mouseleave="onCalendarItemHoverout"
        >
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
            "
          >
            <span></span>
            <span>{{ value.title }}</span>
            <b-icon
              icon="info-circle"
              :title="getCalendarItemTooltip(value.originalItem)"
            />
          </div>
        </div>
      </template>
    </calendar-view>
    <b-loading :active.sync="loading" :is-full-page="false" />
  </div>
</template>

<script>
import moment from "moment";
import "@/assets/calendar/gcal.css";
import { CalendarView, CalendarViewHeader } from "vue-simple-calendar";
import { OrderService } from "@/services/order.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";

export default {
  components: {
    CalendarView,
    CalendarViewHeader,
  },
  props: {
    filters: {
      type: Object,
      default: () => ({}),
    },
    order: {
      type: Object,
    },
    showDate: {
      type: String,
    },
  },
  data: () => ({
    calendarItems: [],
    calendarShowDate: new Date(),
    calendarShownDates: [],
    orderSelected: null,
    loading: false,
  }),
  mounted() {
    this.orderSelected = this.order || null;
  },
  watch: {
    showDate() {
      if (
        this.showDate &&
        !moment(this.showDate).isSame(moment(this.calendarShowDate), "month")
      ) {
        console.log("calendar show date", this.showDate);
        this.calendarShowDate = moment(this.showDate).toDate();
      }
    },
    calendarShowDate() {
      this.generateCalendarItems();
    },
    order() {
      this.orderSelected = this.order;
    },
  },
  methods: {
    async generateCalendarItems(fresh = false) {
      if (fresh) {
        this.calendarItems = [];
        this.calendarShownDates = [];
      }
      if (!this.calendarShowDate) return;

      const monthStart = moment(this.calendarShowDate).startOf("month");
      const monthEnd = moment(this.calendarShowDate).endOf("month");

      this.$emit("generate-items", {
        startDate: monthStart.format("YYYY-MM-DD"),
        endDate: monthEnd.format("YYYY-MM-DD"),
      });

      if (
        this.calendarShownDates.includes(
          moment(this.calendarShowDate).format("MM-YYYY")
        )
      )
        return;
      try {
        this.loading = true;
        const orders = await OrderService.all({
          ...this.filters,
          // 2023-12-01 - Filters required_finish_date instead
          // required_start_date_start: monthStart.tz(moment.tz.guess()).format(),
          // required_start_date_end: monthEnd.tz(moment.tz.guess()).format(),
          required_finish_date_start: monthStart.tz(moment.tz.guess()).format(),
          required_finish_date_end: monthEnd.tz(moment.tz.guess()).format(),
        }).then((response) => JsonDenormalizer.denormalize(response));
        const calendarItems = orders.map((v) => ({
          id: v.id,
          startDate: v.requiredStart ? new Date(v.requiredStart) : null,
          endDate: v.requiredFinish ? new Date(v.requiredFinish) : null,
          title: v.orderId,
          order: v,
        }));
        this.calendarItems = this.calendarItems.concat(calendarItems);
        this.calendarShownDates.push(
          moment(this.calendarShowDate).format("MM-YYYY")
        );
      } catch (err) {
        throw err;
      } finally {
        this.loading = false;
      }
    },
    getCalendarItemTooltip(item) {
      return `Description: ${item.order.workDescription}`;
    },
    onCalendarItemClick(item) {
      this.orderSelected = item.order;
      this.$emit("click-item", item.order);
    },
    onCalendarItemHover(e) {
      let cvItems = document.querySelectorAll(".cv-item");
      for (const cvItem of cvItems) {
        cvItem.classList.remove("isHovered");
      }
      const orderId = e.target.getAttribute("data-order-id");
      cvItems = document.querySelectorAll(`[data-order-id="${orderId}"]`);
      for (const cvItem of cvItems) {
        cvItem.classList.add("isHovered");
      }
    },
    onCalendarItemHoverout(e) {
      let cvItems = document.querySelectorAll(".cv-item");
      for (const cvItem of cvItems) {
        cvItem.classList.remove("isHovered");
      }
    },
  },
};
</script>

<style lang="scss">
.order-calendar {
  height: 100%;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/Order/OrderCalendar.vue